module.exports = __webpack_public_path__ + "static/media/Slunecna.13b84957.md";